module.exports = __webpack_public_path__ + "static/media/w3.4de34bf0.png";